"use client";

import { c as _c } from "react/compiler-runtime";
import { Command as CommandPrimitive } from "cmdk";
import { createContext, useContext, useMemo, useState } from "react";
import { useIsMountedRef } from "../../hooks";
import { Search } from "../../icons/material-symbols/outlined/Search";
import { classNames } from "../../utils";
import { CenterAligned } from "../CenterAligned";
import { Input } from "../Input";
import { Item, ItemAvatar, ItemContent, ItemDescription, ItemSide, ItemTitle } from "../Item";
import { TextBody } from "../Text";
import { textBodyVariants } from "../Text/TextBody";
const CommandContext = createContext({
  setLocalValue: () => {},
  onSelect: () => {}
});
function Command(t0) {
  const $ = _c(18);
  let className;
  let onSelect;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      onSelect,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onSelect;
    $[3] = props;
  } else {
    className = $[1];
    onSelect = $[2];
    props = $[3];
  }
  const [localValue, setLocalValue] = useState("");
  const isMountedRef = useIsMountedRef();
  let t1;
  let t2;
  if ($[4] !== onSelect) {
    t2 = {
      setLocalValue,
      onSelect
    };
    $[4] = onSelect;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  t1 = t2;
  const value = t1;
  let t3;
  if ($[6] !== className) {
    t3 = classNames("flex size-full flex-col gap-3", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isMountedRef.current) {
    t4 = e => {
      if (isMountedRef.current) {
        setLocalValue(e);
      }
    };
    $[8] = isMountedRef.current;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== localValue || $[11] !== props || $[12] !== t3 || $[13] !== t4) {
    t5 = <CommandPrimitive className={t3} onValueChange={t4} value={localValue} {...props} />;
    $[10] = localValue;
    $[11] = props;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5 || $[16] !== value) {
    t6 = <CommandContext.Provider value={value}>{t5}</CommandContext.Provider>;
    $[15] = t5;
    $[16] = value;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
export function CommandInput(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Search fill="text-secondary" size={18} />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CommandPrimitive.Input />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== className || $[6] !== props) {
    t3 = <Input asChild={true} className={className} startEnhancer={t1} {...props}>{t2}</Input>;
    $[5] = className;
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export function CommandList(t0) {
  const $ = _c(11);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    setLocalValue
  } = useContext(CommandContext);
  let t1;
  if ($[3] !== className) {
    t1 = classNames("gap-0.5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== setLocalValue) {
    t2 = () => setLocalValue("");
    $[5] = setLocalValue;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t2) {
    t3 = <CommandPrimitive.List className={t1} onPointerLeave={t2} {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export function CommandEmpty(t0) {
  const $ = _c(10);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames("py-6 text-center", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest) {
    t2 = <CommandPrimitive.Empty {...rest} />;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <TextBody asChild={true} className={t1} size="sm" weight="semibold">{t2}</TextBody>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function CommandItem(t0) {
  const $ = _c(18);
  let className;
  let disabled;
  let onSelect;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      onSelect,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = onSelect;
    $[4] = props;
  } else {
    className = $[1];
    disabled = $[2];
    onSelect = $[3];
    props = $[4];
  }
  const {
    onSelect: onSelectContext
  } = useContext(CommandContext);
  let t1;
  if ($[5] !== className) {
    t1 = classNames("rounded border-0 px-2 py-1.5 focus:outline-hidden aria-selected:bg-bg-additional-1", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = Boolean(onSelect);
  let t3;
  if ($[7] !== onSelect || $[8] !== onSelectContext) {
    t3 = value => {
      onSelect?.(value);
      onSelectContext?.(value);
    };
    $[7] = onSelect;
    $[8] = onSelectContext;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props || $[11] !== t3) {
    t4 = <CommandPrimitive.Item {...props} onSelect={t3} />;
    $[10] = props;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== disabled || $[14] !== t1 || $[15] !== t2 || $[16] !== t4) {
    t5 = <Item asChild={true} className={t1} disabled={disabled} interactive={t2}>{t4}</Item>;
    $[13] = disabled;
    $[14] = t1;
    $[15] = t2;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
export const CommandItemAvatar = ItemAvatar;
export const CommandItemTitle = ItemTitle;
export const CommandItemDescription = ItemDescription;
export const CommandItemContent = ItemContent;
export const CommandItemSide = ItemSide;
export function CommandShortcut(t0) {
  const $ = _c(12);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("size-6 rounded bg-bg-additional-1", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <TextBody size="sm">{children}</TextBody>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== rest || $[9] !== t1 || $[10] !== t2) {
    t3 = <CenterAligned className={t1} {...rest}>{t2}</CenterAligned>;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function CommandGroup(t0) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames("[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5", textBodyVariants({
      size: "sm",
      weight: "regular"
    }), className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest || $[6] !== t1) {
    t2 = <CommandPrimitive.Group className={t1} {...rest} />;
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}

/**
 * The Command component is a general-use typeahead that shows a list of items filtered by the input.
 * This component is primarily used to be a part of a Combobox.
 * https://ui.shadcn.com/docs/components/command
 * TODO(robert): We may need to re-look this component entirely either from scratch or until we can find a suitable alternative.
 */
export { Command, CommandItem };